<template>
	<div v-show="dataLoaded">
		<personal-profile-data-view
			:editable="editable"
			:personal-data="formData.personalData"
			@edition-status="personalDataEditionStatus"
		></personal-profile-data-view>

		<department-profile-data-view
			:editable="editable"
			v-if="formData.departmentData !== null"
			:department-data="formData.departmentData"
			@edition-status="departmentDataEditionStatus"
		></department-profile-data-view>

		<agency-profile-data-view
			v-if="formData.agencyData !== null"
			:agency-data="formData.agencyData"
			@edition-status="agencyDataEditionStatus"
		></agency-profile-data-view>

		<v-layout row class="mb-4">
			<v-flex xs3/>
			<v-flex xs5>
				<v-alert
					:value="showAlert"
					type="info"
					outline
				>{{alertMessage}}
				</v-alert>
			</v-flex>
		</v-layout>

		<v-layout row v-if="editable">
			<v-flex xs4/>
			<v-flex xs3>
				<v-btn block color="accent" dark class="mt-2 mb-5" @click="save">Zapisz zmiany</v-btn>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import {Profile} from "@/api/generated/Profile";
	import PersonalProfileDataView from "./components/PersonalProfileDataView";
	import DepartmentProfileDataView from "./components/DepartmentProfileDataView";
	import AgencyProfileDataView from "./components/AgencyProfileDataView";

	export default {
		name: "InnerUserProfileView",
		components: {
			AgencyProfileDataView,
			DepartmentProfileDataView,
			PersonalProfileDataView
		},

		data () {
			return {
				formData: {},
				personalDataEditable: false,
				departmentDataEditable: false,
				agencyDataEditable: false,
				showAlert: false,
				alertMessage: '',
				dataLoaded: false
			};
		},

		props: {
			editable: {
				default: true,
			},
		},

		methods: {
			personalDataEditionStatus (status) {
				this.personalDataEditable = status;
			},

			departmentDataEditionStatus (status, departmentData) {
				this.departmentDataEditable = status;
				this.formData.departmentData = departmentData;
			},

			agencyDataEditionStatus (status, agencyData) {
				this.agencyDataEditable = status;
				this.formData.agencyData = agencyData;
			},

			save () {
				if (this.personalDataEditable || this.departmentDataEditable || this.agencyDataEditable) {
					this.alertMessage = 'Aby zapisać zmiany, skończ edycję danych!';
					this.showAlert = true;
				} else {
					this.showAlert = false;
					Profile.putInnerUserProfile(this, this.formData, successResponse => {
						this.$messagesBus.$emit("success", "Zmiany zostały pomyślnie zapisane", successResponse);
						this.refresh();
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać zmiany", errorResponse);
					});
				}
			},

			refresh () {
				Profile.getInnerUserProfile(this, this.$route.params.userId, successResponse => {
					this.formData = successResponse;
					this.dataLoaded = true;
				}, errorResponse => {
					if (errorResponse.error === "access_denied") {
						this.$router.push("/forbidden");
					} else {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych profilowych", errorResponse);
					}
				});
			}
		},

		created () {
			this.refresh();
		},
	};
</script>

<style scoped>

</style>
